import React, { ReactNode } from 'react'
import * as styles from './LogoCarousel.module.scss'

interface SliderProps {
  children: ReactNode
  count?: 8|9
}

const animationDuration = 40

const Slider: React.FC<SliderProps> = ({ children, count = 8 }: SliderProps) => {
  return (
    <div
      className={styles.slider}
    >
      <div
        className={`${styles.slideTrack} ${count === 9 ? styles.wide : ''}`}
        style={{
          animationName: count === 8 ? styles.scroll8 : styles.scroll9,
          animationDuration: (count * animationDuration / 8) + 's'
        }}
      >
        {children}
        {children}
      </div>
    </div>
  )
}

export default Slider
